import { render } from "./NotificationMessage.vue?vue&type=template&id=72f7f6ee&scoped=true&ts=true"
import script from "./NotificationMessage.vue?vue&type=script&lang=ts"
export * from "./NotificationMessage.vue?vue&type=script&lang=ts"

import "./NotificationMessage.vue?vue&type=style&index=0&id=72f7f6ee&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f7f6ee"]])

export default __exports__